class Launcher {
    openGame(url, title = 'playgame', w = 1600, h = 900) {
        if (typeof this.windows === "undefined") {
            this.windows = [];
        }
        if (this.windows.length) {
            for (let i in this.windows) {
                if (this.windows[i].closed) {
                    delete this.windows[i];
                } else if (this.windows[i].name !== "") {
                    this.windows[i].focus();
                }
            }
        }
        return this.windowMode(url, title, w, h);
    }

    windowMode(url, title, w, h) {
        if (typeof this.windows === "undefined") {
            this.windows = [];
        }
        let wi = window.open(url, title, "location=0,menubar=0,scrollbars=0,status=0,titlebar=0,toolbar=0,width=" + Math.min(screen.width * 0.8, 1300) + ",height=" + Math.min(screen.height * 0.8, 800) + ",popup=1");
        if (wi) {
            if (typeof app.config === "object" && typeof app.config.user === "object") {
                this.placeScreen(wi, parseInt(app.storage.get("GameSize:" + app.config.user.id + ":" + url)));
            } else {
                this.placeScreen(wi, 50);
            }

            this.windows.push(wi);
        }

        return wi;
    }

    tabMode(url, title) {
        window.open(url, title).focus();
    }

    setupRotation() {
        let pos = parseInt(app.storage.get("GameSize:" + app.config.user.id + ":" + window.location.pathname));
        if (!pos) {
            pos = 0;
        }
        this.currentScreenPosition = pos;
    }

    rotateButton(pos) {
        let el = $("#screen-rotation");
        el.find("img").css({"display": "none"});
        let nextPos = pos;
        if (nextPos > 0 && nextPos < 8) {
            nextPos++;
        } else {
            nextPos = 1;
        }
        el.find("img[data-mode='" + nextPos + "'").css({"display": "block"});
    }

    setScreen(pos) {
        if (typeof this.currentScreenPosition === "undefined") {
            this.currentScreenPosition = 0;
        }
        if (pos === 0) {
            pos = this.currentScreenPosition;
            if (pos > 0 && pos < 8) {
                pos++;
            } else {
                pos = 1;
            }
            this.currentScreenPosition = pos;
        }
        switch (pos) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 50:
            case 99:
                this.placeScreen(window, pos);
                $('.screen-size-buttons').slideUp(200);
                app.storage.set("GameSize:" + app.config.user.id + ":" + window.location.pathname, pos);
                break;
            case 100:
                this.toggleFullscreen();
                break;
        }
    }

    toggleFullscreen() {
        const fsElem = document.webkitFullscreenElement || document.fulscreenElement || document.mozFullScreenElement;
        if (!fsElem) {
            if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    placeScreen(window, pos) {
        switch (pos) {
            case 1:
                window.resizeTo(screen.width * 0.5, screen.height * 0.5);
                window.moveTo(0, 0);
                break;

            case 2:
                window.resizeTo(screen.width * 0.5, screen.height * 0.5);
                window.moveTo(screen.width * 0.5, 0);
                break;

            case 3:
                window.resizeTo(screen.width * 0.5, screen.height * 0.5);
                window.moveTo(0, screen.height * 0.5);
                break;

            case 4:
                window.resizeTo(screen.width * 0.5, screen.height * 0.5);
                window.moveTo(screen.width * 0.5, screen.height * 0.5);
                break;

            case 5:
                window.resizeTo(screen.width * 0.5, screen.height);
                window.moveTo(0, 0);
                break;

            case 6:
                window.resizeTo(screen.width, screen.height * 0.5);
                window.moveTo(0, 0);
                break;

            case 7:
                window.resizeTo(screen.width * 0.5, screen.height);
                window.moveTo(screen.width * 0.5, 0);
                break;

            case 8:
                window.resizeTo(screen.width, screen.height * 0.5);
                window.moveTo(screen.height * 0.5, screen.height);
                break;

            case 99:
                if (screen.width > screen.height) {
                    let w = Math.min(screen.height * 1.77, screen.width);
                    window.resizeTo(w, screen.height);
                    window.moveTo((screen.width * 0.5) - (w * 0.5), 0);
                } else {
                    window.resizeTo(screen.width, screen.height);
                    window.moveTo(0, 0);
                }
                break;

            case 50:
            default:
                if (screen.width > screen.height) {
                    let h = screen.height * 0.7;
                    let w = Math.min(h * 1.85, screen.width);
                    window.resizeTo(w, h);
                    window.moveTo((screen.width * 0.5) - (w * 0.5), 0);
                } else {
                    window.resizeTo(screen.width * 0.75, screen.height * 0.75);
                    window.moveTo(screen.width * 0.125, 0);
                }
                break;
        }
    }
}